export default "__VITE_ASSET__ac8efef9__"